import store from "@/store";
import { isCustomDomain } from "@/utils/custom-domain";
import { platformSignInUrl, rememberedReferral } from "@/utils/custom-domain-auth";

/*
  開啟登入對話框（2026-10-21）。

  在網站裡按「登入」、或點到要登入才能看的頁面時，原地跳出登入對話框（components/Common/LoginDialog.vue），
  登入完留在原本的頁面（或繼續前往 after），不用換到登入頁再被導回來。

  子站自訂網域例外：登入一律要在平台網域做（Cookie 屬於 .kf-9595.com，見 utils/custom-domain-auth.js），
  照舊轉到平台登入、再用交接碼帶回來。

  after：登入完要前往的站內路徑（例如 /center?tab=order）；沒給就留在原頁面
  refc ：推薦碼（網址上的 ?refc=）。沒給就用這個分頁進站時記下的（分享連結進來、逛到別頁才按登入）
  view ：先顯示哪一個，SignIn（登入）或 SignUp（註冊）

  推薦碼跟登入頁的規則一樣：這次有推薦碼就記著，帳密登入、Google、Email 註冊都會帶給後端；
  沒有就清掉，不讓很久以前點過的推薦碼套到現在。社群邀請（ivtem）只走登入頁，這裡一併清掉。

  切換帳號（utils/accountSwitch.js）另外用到：
  email ：帶入這個帳號（App 不帶入記住的密碼 —— 切換時已經用過了，還走到這裡代表不能用）
  blank ：什麼都不帶入（「登入其他帳號」）
  notice：表單上方的說明（例如「這個帳號用 Google 登入」）
  reload：登入完整頁重新載入；關掉沒登入就回首頁（已經登出了，原本的頁面可能要登入才看得到）
*/
/**
 * 這些頁面本身就是登入流程（登入頁、登入交接、內嵌登入、Google 登入完成、App 帶回），不跳登入對話框 ——
 * 例如別的裝置把這台登出、這台被帶到登入頁時，不該同時再疊一個對話框
 */
export const LOGIN_FLOW_ROUTES = ["SignIn", "AuthHandoff", "EmbedLogin", "LoginSuccess", "AppReturn"];

export function openLoginDialog({ after = null, refc = null, view = "SignIn", email = null, blank = false, notice = null, reload = false } = {}) {
  if (/^\/(signin|auth\/|embed\/|loginsuccess|app-return)/i.test(window.location.pathname)) return;

  const fromArg = typeof refc === "string" && refc.trim() !== "" ? refc.trim() : null;
  const referral = fromArg || rememberedReferral() || null;

  if (isCustomDomain()) {
    const returnUrl = after ? new URL(after, window.location.origin).toString() : window.location.href;
    window.location.href = platformSignInUrl({ status: view === "SignUp" ? "SignUp" : "SignIn", returnUrl, refc: referral });
    return;
  }

  try {
    if (referral) localStorage.setItem("referral_code", referral);
    else localStorage.removeItem("referral_code");
    localStorage.removeItem("inviterEmail");
    localStorage.removeItem("inviterQuery");
  } catch (e) {
    /* 略過 */
  }
  store.commit("OpenLoginDialog", { after, view, email, blank, notice, reload });
}
